import { useEffect, useState } from 'react';
import { formatDistanceToNow } from 'date-fns';
import MiddleEllipsis from 'react-middle-ellipsis';
import { Loading } from '../loading';
import { ToggleCaret } from '../input';
import { State } from './State';
import { Runtime } from './Runtime';
import { StopButton } from './StopButton';
import { Info } from './Info';
import { styles, isRunning, isDone } from './shared';
import { DisplayPrompt } from './DisplayPrompt';

export const Controls = ({ job }) => {
  const [messages, setMessages] = useState([]);
  const [open, setOpen] = useState(true);

  const size = 18;

  // useEffect(() => {
  //   const l = [...(job?.progress?.messages || [])];
  //   setMessages(l);
  // }, [job?.progress?.messages]);

  const borderRadius = 5;
  const nodes = messages
    .sort((a, b) => b.createdAt - a.createdAt)
    .slice(0, 10)
    .map(({ loading, createdAt, updatedAt, body }, idx) => {
      const ts = new Date();
      ts.setTime(createdAt);
      let d;
      try {
        d = formatDistanceToNow(ts, { addSuffix: true });
      } catch (e) {
        console.log(e, ts, createdAt);
        d = 'invalid';
      }
      return (
        <div
          key={idx}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            fontSize: 11,
            fontFamily: 'monospace',
            padding: '2px 4px',
            background: '#f8f8f8',
            borderRadius: idx == 0 ? borderRadius : 0,
          }}
        >
          {loading && <Loading size={14} />}
          <div style={{ flex: 1, ...styles.textOverflowStyle }}>
            <MiddleEllipsis>
              <span>{body}</span>
            </MiddleEllipsis>
          </div>
          <div>{d}</div>
        </div>
      );
    });

  let message;
  if (isRunning(job?.state) && messages.length) {
    message = messages[0].body;
  }

  const margin = 10;

  return (
    <div
      style={{
        borderRadius: 8,
        border: '1px solid #d3d3d3',
        backgroundx: '#f8f8f8',
      }}
    >
      <DisplayPrompt job={job} />

      <div
        style={{
          borderRadius: 5,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            fontSize: 12,
            padding: 10,
            borderRadius: 5,
            cursor: 'pointer',
          }}
          onClick={() => setOpen(!open)}
        >
          <div
            style={{
              gap: 5,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <ToggleCaret open={open} size={size} />
            <State job={job} size={size} />
          </div>
          <StopButton job={job} size={size} />
          <div>{message}</div>
          {isRunning(job?.state) && <div style={{ flex: 1 }}></div>}
          <Runtime job={job} />
          {/*<div style={{ ...styles.mono, color: '#888' }}>{job?.id}</div>*/}
        </div>

        {open && (
          <div style={{ margin: '0 10px 10px 10px' }}>
            <Info job={job} />
          </div>
        )}
      </div>
    </div>
  );
};
